import React from 'react';
import PropTypes from 'prop-types';

import IconError from '../IconError';

import common from './formElementStyles/commonFormElements.module.css';
import textArea from './formElementStyles/textArea.module.css';

const TextAreaField = ({
    id = '',
    label = '',
    subLabel = '',
    placeholder = '',
    disabled = false,
    mandatory = false,
    value,
    customClass = '',
    customLabelClass = '',
    error = {},
    onChange,
    rows = 5,
    count = '',
    readOnly = false,
    maxLength = 300000,
    autoComplete = 'off'
}) => {
    return (
        <div
            className={`${common.fieldWrapper} ${textArea.textAreaWrapper} ${customClass ? common[customClass] : ''}`}>
            <label htmlFor={id} className={`${common.formLabel} ${customLabelClass ? common[customLabelClass] : ''}`}>
                <span>
                    {label} {mandatory && <sup>*</sup>}
                </span>
            </label>
            {subLabel && <div>{subLabel}</div>}
            <textarea
                id={id}
                role="textbox"
                data-testid={`textField${id}`}
                aria-required={mandatory}
                disabled={disabled}
                placeholder={placeholder}
                autoComplete={autoComplete}
                value={value}
                rows={rows}
                maxLength={maxLength}
                readOnly={readOnly}
                className={textArea.textarea}
                onChange={onChange}
            />
            {count && <div data-testid={`${id}-count`}>{count}</div>}
            {error?.error && (
                <div className={textArea.error}>
                    <IconError text={error} />
                </div>
            )}
        </div>
    );
};

TextAreaField.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    subLabel: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    mandatory: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    customClass: PropTypes.string,
    customLabelClass: PropTypes.string,
    error: PropTypes.object,
    onChange: PropTypes.func,
    rows: PropTypes.number,
    count: PropTypes.string,
    readOnly: PropTypes.bool,
    maxLength: PropTypes.number,
    autoComplete: PropTypes.string
};

export default TextAreaField;
